export default __webpack_public_path__ + "static/basset-hound-ffcbd4726e45cfd88a252eaf94a3b7f7.jpg";